/**
 * cameraDisplayLabel — the ONE source of truth for a camera's on-screen label across Live AND Playback
 * (live tile overlay, playback tile caption, timeline band, drag ghost, actions header). Both viewers
 * historically composed this inline and drifted — playback never learned the eView form, so cross-NVR
 * cameras read without their server name. #86bb7phhh consolidates every site onto this helper.
 *
 *   eView : "ServerName : CamName"  — the member-NVR name disambiguates cams across servers (Live's format).
 *   local : "CameraID - CamName"    — the single-NVR form.
 *
 * `bSerial` gates the eView branch exactly as Live does (a cloud cam has bSerial 0 → falls to local form).
 * Accepts either the Live camera shape (`bID`) or the playback slot shape (`bCamera`) for the id — whichever
 * is present. Null-safe (→ ''); id-less cam → bare name.
 */
export const cameraDisplayLabel = (cam, { isEview = false } = {}) => {
  if (!cam) return '';
  const name = cam.sName || '';
  // Empty-slot placeholder (fEnable:false — blankSlot / selectView empties): a "+ Add camera" stand-in,
  // not a real camera. Return '' → no label at all (David: show nothing on empty slots).
  if (cam.fEnable === false) return '';
  if (isEview && cam.bSerial) return `${cam.sServerName || 'NVR'} : ${name}`;
  const id = cam.bID != null ? cam.bID : cam.bCamera;
  return id != null ? `${id} - ${name}` : name;
};
